import { useEffect, useMemo } from 'react';
import * as Sentry from '@sentry/react';
import useWindowSize from '@sv-support-sdk/utils/src/hooks/useWindowSize';

import { useAppDispatch } from '../store/hooks';
import { setMobile, setTablet } from '../store/slices/appState';

const useMobileDetect = () => {
  const dispatch = useAppDispatch();
  const [width] = useWindowSize();

  const isMobile = useMemo(() => width < 1100, [width]);
  const isTablet = useMemo(() => width > 600 && width < 1100, [width]);

  useEffect(() => {
    dispatch(setMobile(isMobile));
    dispatch(setTablet(isTablet));
    Sentry.setTag('application', isMobile ? 'mobile' : 'desktop');
  }, [dispatch, isMobile, isTablet]);

  return isMobile;
};

export default useMobileDetect;
